export default __webpack_public_path__ + "static/media/StandorteUndLieferzeiten.4f5389fc.jpg";